import React from 'react'
import { connect } from 'react-redux'

import Search from 'components/Search'
import Button from 'components/Button'
import ModalAddControllersToGroups from '../components/Controllers/Modals/ModalAddControllersToGroups'
import ModalCardController from '../components/Controllers/Modals/ModalCardController'
import ModalAlert from 'components/ModalAlert'
import Pagination from 'components/Pagination'
import ControllersListItem from '../components/Controllers/ControllersListItem'

import { SETTINGS_PAGINATION, MODAL_ALERT_TYPES } from 'utils/consts'
import {
  toggleItem,
  toggleAllItems,
  onChangePagination,
  changeVisibillityModalAlert,
  onChangeSearch,
} from 'utils/helpers'
import actions from 'store/actions'

class Controllers extends React.Component {
  constructor() {
    super()

    this.toggleItem = toggleItem.bind(this)
    this.toggleAllItems = toggleAllItems.bind(this)
    this.changeVisibillityModalAlert = changeVisibillityModalAlert.bind(this)
    this.onChangeSearch = onChangeSearch.bind(this)
  }

  state = {
    initialItems: [],
    selectedItem: {},
    selectedItems: new Set(),

    modalTitle: '',
    modalText: '',
    searchQuery: '',

    itemsPerPage: SETTINGS_PAGINATION.COUNT_PER_PAGE,
    pageNumber: SETTINGS_PAGINATION.PAGE_NUMBER,

    isAllItemsChecked: false,
    isOpenModalAddControllersToGroups: false,
    isOpenModalCardController: false,

    fetchingData: true,
  }

  componentDidMount() {
    document.title = 'СКУД - Точки доступа'
    this.fetchData(this.state.itemsPerPage, this.state.pageNumber)
  }

  componentDidUpdate(prevProps, prevState) {
    const controller = this.props.controllers.objects.find(
      controller => controller.id === prevState.selectedItem.id
    )

    if (
      controller &&
      controller.groups &&
      this.state.selectedItem.groups &&
      controller.groups.length !== this.state.selectedItem.groups.length
    ) {
      this.setState({ selectedItem: controller })
    }
  }

  /**
   * @param {Number} count
   * @param {Number} page
   * @param {String} title
   */
  fetchData = async (count, page, title) => {
    try {
      const response = await this.props.fetchControllers({ count, page, title })
      this.setState({ initialItems: response.objects })
    } catch (error) {
      this.changeVisibillityModalAlert(MODAL_ALERT_TYPES.TYPE_ERROR, error)
    } finally {
      this.setState({ fetchingData: false })
    }
  }

  changeVisibillityModalAddControllersToGroups = () => {
    this.setState(prevState => ({
      isOpenModalAddControllersToGroups: !prevState.isOpenModalAddControllersToGroups,
    }))
  }

  /**
   *
   * @param {Object} selectedItem
   */
  changeVisibillityModalCardController = (selectedItem = {}) => {
    this.setState(prevState => ({
      isOpenModalCardController: !prevState.isOpenModalCardController,
      selectedItem,
    }))
  }

  render() {
    const {
      initialItems,
      selectedItem,
      selectedItems,

      modalTitle,
      modalText,

      itemsPerPage,
      pageNumber,
      searchQuery,

      isAllItemsChecked,
      isOpenModalAddControllersToGroups,
      isOpenModalAlert,
      isOpenModalCardController,
      fetchingData,
    } = this.state

    const items = this.props.controllers.objects || [],
      countPages = this.props.controllers.page_count,
      forcePage = this.props.controllers.page_num

    return (
      <>
        {initialItems.length ? (
          <>
            <div className='top-controls'>
              <div className='wrapper-controls'>
                <Search
                  itemsPerPage={itemsPerPage}
                  fetchItems={this.props.fetchControllers}
                  onChangeSearch={this.onChangeSearch}>
                  {!!selectedItems.size && (
                    <div className='btn-group'>
                      <Button
                        title='Добавить в группу'
                        className='btn--link btn--link-black'
                        action={
                          this.changeVisibillityModalAddControllersToGroups
                        }
                      />
                    </div>
                  )}
                </Search>
              </div>
            </div>

            {!!items.length ? (
              <>
                <div className='table-wrapper'>
                  <table className='table'>
                    <thead>
                      <tr>
                        <td className='table__checkbox'>
                          <input
                            type='checkbox'
                            onChange={() => this.toggleAllItems(items)}
                            checked={isAllItemsChecked}
                            title='Выбрать все точки доступа на странице'
                          />
                        </td>
                        <td className='table__photo'>Фото</td>
                        <td colSpan='2'>Название</td>
                      </tr>
                    </thead>
                    <tbody>
                      {items.map(controller => (
                        <ControllersListItem
                          key={controller.id}
                          controller={controller}
                          selectedControllers={selectedItems}
                          openModal={this.changeVisibillityModalCardController}
                          toggleController={e => this.toggleItem(e)}
                        />
                      ))}
                    </tbody>
                  </table>
                </div>

                <Pagination
                  items={items}
                  forcePage={forcePage}
                  pageCount={countPages}
                  searchQuery={searchQuery}
                  changePagination={onChangePagination.bind(this)}
                />
              </>
            ) : fetchingData ? (
              ''
            ) : (
              <div className='not-found'>
                <p>По вашему запросу ничего не найдено.</p>
              </div>
            )}
          </>
        ) : fetchingData ? (
          ''
        ) : (
          <div className='not-exist'>
            <p>У вас не заведена ни одна точка доступа.</p>
          </div>
        )}

        {isOpenModalAddControllersToGroups && (
          <ModalAddControllersToGroups
            selectedControllers={selectedItems}
            itemsPerPage={itemsPerPage}
            pageNumber={pageNumber}
            openModalAlert={this.changeVisibillityModalAlert}
            closeModal={this.changeVisibillityModalAddControllersToGroups}
          />
        )}
        {isOpenModalCardController && (
          <ModalCardController
            controller={selectedItem}
            itemsPerPage={itemsPerPage}
            pageNumber={pageNumber}
            openModalAlert={this.changeVisibillityModalAlert}
            closeModal={this.changeVisibillityModalCardController}
          />
        )}

        {isOpenModalAlert && (
          <ModalAlert
            modalTitle={modalTitle}
            modalText={modalText}
            closeModal={this.changeVisibillityModalAlert}
          />
        )}
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    controllers: state.controllersInfo,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchControllers: data => dispatch(actions.controllers.fetchControllers(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Controllers)
